import loginConfig from "./login/en";
import usersConfig from "./users/en";
import sidebarConfig from "./sidebar/en";
import topbarConfig from "./topbar/en";
import sliderConfig from "./slider/en";
import toastMessages from "./toastMessages/en";
const translations = {
  "common.English": "English",
  "common.English.short": "Eng",
  "common.Georgian": "Georgian",
  "common.Georgian.short": "Geo",
  "common.Hello": "Hello",
  "common.Operation.Successfully": "Operation Successfully",
  "common.Sure": "Are you sure?",
  "common.Male": "Male",
  "common.Female": "Female",
  "common.IsActive": "Is Active",
  "common.PageNotFound": "Page Not Found",
  "common.PageLoadFailed": "Page Load Failed",
  "common.PageCrashed": "Page Crashed",
  "common.NoRowsToShow": "No Rows To Show",

  ...loginConfig,
  ...usersConfig,
  ...sidebarConfig,
  ...topbarConfig,
  ...sliderConfig,
  ...toastMessages,
};

export default translations;
